import { ProspectType, ProspectCategory } from './prospect.types';

/**
 * Type for the response data item from the generate upload URL mutation.
 */
type UploadFileUrl = {
  presignedUrl: string;
  key: string;
};

/**
 * Type for the response data from the generate upload URL mutation.
 */
export type GenerateUploadUrlResponseData = UploadFileUrl[];

export enum FilePurpose {
  PROSPECT_CREATION = 'PROSPECT_CREATION',
  CALL_CREATION = 'CALL_CREATION',
}

/**
 * Type for the payload data from the generate upload URL mutation.
 */
type BaseFilePayload = {
  name: string;
  type: string;
  size: number;
};

type FilePayloadType = BaseFilePayload &
  (
    | {
        // Category and type are required for prospect creation
        purpose: FilePurpose.PROSPECT_CREATION;
        prospectCategory: ProspectCategory;
        prospectType: ProspectType;
      }
    | {
        purpose?: FilePurpose.CALL_CREATION;
        prospectCategory?: undefined;
        prospectType?: undefined;
      }
  );

/**
 * Type for the payload data from the generate upload URL mutation.
 */
export type GenerateUploadUrlPayload = {
  files: FilePayloadType[];
};

/**
 * Type for the status of the file upload.
 */
export enum FileStatus {
  UPLOADING = 'uploading',
  SUCCESS = 'success',
  ERROR = 'error',
}

/**
 * Type for the file upload status.
 */
export type FileDataType = {
  id: string;
  file: File;
  status: FileStatus;
  progress: number;
};
